import React, { useCallback, useState } from 'react';
import { bool, func, string } from 'prop-types';
import './SegmentNameModal.scss';
import TextBox from 'react/components/common/TextBox/TextBox';
import ModalWithConfirmationButtons from 'react/components/common/Modal/ModalWithConfirmationButtons/ModalWithConfirmationButtons';

/**
 * SegmentNameModal - Modal for naming a segment before category activation
 * Similar to AudienceNameModal but with segment-specific text
 */
const SegmentNameModal = ({ isOpen, initialName, onCancel, onSubmit }) => {
  const [name, setName] = useState(initialName);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = useCallback(async () => {
    if (!name.trim()) return;
    setIsLoading(true);
    try {
      await onSubmit(name.trim());
    } finally {
      setIsLoading(false);
    }
  }, [name, onSubmit]);

  const handleChange = useCallback(({ target: { value } }) => {
    setName(value);
  }, []);

  const handleCancel = useCallback(() => {
    setName(initialName);
    onCancel();
  }, [initialName, onCancel]);

  return (
    <div className="segment-name-modal-component" role="dialog" aria-label="Set Segment Name Dialog">
      <ModalWithConfirmationButtons
        hasScrollContainer={false}
        isLightTheme={true}
        isOpen={isOpen}
        isCancelTransparent={true}
        isSubmitDisabled={isLoading || !name.trim()}
        isCancelDisabled={isLoading}
        modalTitle="Segment must be named before activating"
        showSeparator={false}
        submitLabel="Save and Activate"
        width={500}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
        confirmationButtonsWidth="auto"
      >
        <div className="label">Segment name:</div>
        <TextBox
          value={name}
          placeholder="Untitled Segment"
          isDarkTheme={false}
          isDisabled={isLoading}
          onChange={handleChange}
          onEnter={handleChange}
          isFocused={true}
        />
      </ModalWithConfirmationButtons>
    </div>
  );
};

SegmentNameModal.propTypes = {
  isOpen: bool.isRequired,
  initialName: string,
  onCancel: func.isRequired,
  onSubmit: func.isRequired,
};

SegmentNameModal.defaultProps = {
  initialName: '',
};

export default SegmentNameModal;
